import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AppgenAuditService {
  constructor(private http: HttpClient) {}

  auditDragList: any = [];
  //STORE
  auditV2 = {
    fieldName: '',
    fieldId: '',
    fieldType: '',
    status: '',
    dragDetails: {
      previousIndex: 0,
      currentIndex: 0,
      prevParentComp: {},
      currParentComp: {},
      status: false,
      key: 'DragConfiguration',
    },
    fieldJson: {
      finalData: {},
      oldData: {},
      status: false,
      key: 'FieldConfiguration',
    },
    ruleJson: {
      finalData: {},
      oldData: {},
      status: false,
      key: 'RuleConfiguration',
    },
    tableJson: {
      finalData: [],
      oldData: [],
      status: false,
      key: 'TableConfiguration',
    },
    roleJson: {
      finalData: [],
      oldData: [],
      status: false,
      key: 'RoleConfiguration',
    },
    eventJson: {
      finalData: [],
      oldData: [],
      status: false,
      key: 'EventConfiguration',
    },
    validateJson: {
      finalData: [],
      oldData: [],
      status: false,
      key: 'ValidateConfiguration',
    },
    sideTableConfig: {
      finalData: [],
      oldData: [],
      status: false,
      key: 'TableConfig',
    },
  };

  // GET METHODS
  getAppgenAudit(dataForPost): Observable<any> {
    return this.http.post(`/appgen/appgen-config-audit`, dataForPost).pipe(
      map((response: any) => response?.data),
      catchError((error) => throwError(error))
    );
  }

  //FUNCTIONS
  fieldAudit($event, isDraggedFromPalette, jsonDataRaw): any {
    // AUDIT START
    let finalData = { ...$event.attributeJ };
    let compareData: any;
    if (isDraggedFromPalette) {
      compareData = {};
      this.auditV2.status = 'Added';
    } else {
      compareData = JSON.parse(jsonDataRaw)?.com
        ? JSON.parse(jsonDataRaw)?.com
        : JSON.parse(jsonDataRaw);
    }
    const fieldId = compareData.id;
    const fieldType = $event.attributeJ.componentType;
    const fieldName = $event.attributeJ.label
      ? $event.attributeJ.label
      : $event.attributeJ.ariaLabel;
    this.auditV2.fieldId = fieldId;
    this.auditV2.fieldName = fieldName;
    this.auditV2.fieldType = fieldType;

    Object.keys(finalData).forEach((ele) => {
      if (compareData.hasOwnProperty(ele)) {
        if (finalData[ele]) {
          this.compareFunc(finalData[ele], compareData[ele], ele);
        }
      } else {
        if (finalData[ele]) {
          this.compareFunc(finalData[ele], '', ele);
        }
      }
    });
    // this.formbuilderService.auditData.splice(0, 0, this.auditV2);
    return this.auditV2;
  }

  //RESET AUDITV2
  resetAuditV2() {
    this.auditV2 = {
      fieldName: '',
      fieldId: '',
      fieldType: '',
      status: '',
      dragDetails: {
        previousIndex: 0,
        currentIndex: 0,
        prevParentComp: {},
        currParentComp: {},
        status: false,
        key: 'DragConfiguration',
      },
      fieldJson: {
        finalData: {},
        oldData: {},
        status: false,
        key: 'FieldConfiguration',
      },
      ruleJson: {
        finalData: {},
        oldData: {},
        status: false,
        key: 'RuleConfiguration',
      },
      tableJson: {
        finalData: [],
        oldData: [],
        status: false,
        key: 'TableConfiguration',
      },
      roleJson: {
        finalData: [],
        oldData: [],
        status: false,
        key: 'RoleConfiguration',
      },
      eventJson: {
        finalData: [],
        oldData: [],
        status: false,
        key: 'EventConfiguration',
      },
      validateJson: {
        finalData: [],
        oldData: [],
        status: false,
        key: 'ValidateConfiguration',
      },
      sideTableConfig: {
        finalData: [],
        oldData: [],
        status: false,
        key: 'TableConfig',
      },
    };
  }

  compareFunc(finalDataValue, compareDataValue, element) {
    if (JSON.stringify(finalDataValue) != JSON.stringify(compareDataValue)) {
      // NOT EQUAL
      if (
        finalDataValue != '' &&
        element != 'comboMapValues' &&
        element != 'componentType' &&
        element != 'pkAttrDtlId'
      ) {
        this.auditV2.fieldJson.finalData[element] = finalDataValue;
        this.auditV2.fieldJson.oldData[element] = compareDataValue;
        this.auditV2.fieldJson.status = true;
      }
    }
  }

  TableAudit(tableData, isDraggedFromPalette, jsonDataRaw): any {
    // AUDIT START
    let finalData = JSON.parse(tableData);
    let compareData: any;
    if (isDraggedFromPalette) {
      compareData = [];
    } else {
      compareData = JSON.parse(jsonDataRaw)?.com
        ? JSON.parse(jsonDataRaw)?.com.fieldColumnConfig
        : JSON.parse(jsonDataRaw);
      if (!this.auditV2.fieldName || !this.auditV2.fieldType) {
        const fieldId = JSON.parse(jsonDataRaw)?.com?.id;
        const fieldType = JSON.parse(jsonDataRaw)?.com?.componentType;
        const fieldName = JSON.parse(jsonDataRaw)?.com?.label;
        this.auditV2.fieldId = fieldId;
        this.auditV2.fieldName = fieldName;
        this.auditV2.fieldType = fieldType;
      }
    }

    this.compareFuncForArray(finalData, compareData, 'Table');
    return this.auditV2;
  }

  roleAudit(roleData, isDraggedFromPalette, jsonDataRaw): any {
    // AUDIT START
    let finalData = JSON.parse(roleData);
    let compareData: any;
    if (isDraggedFromPalette) {
      compareData = [];
    } else {
      compareData = JSON.parse(jsonDataRaw)?.com
        ? JSON.parse(jsonDataRaw)?.com.roleConfiguration
          ? [...JSON.parse(jsonDataRaw)?.com.roleConfiguration]
          : []
        : [...JSON.parse(jsonDataRaw)];

      let fcn = JSON.parse(jsonDataRaw)?.fcn;
      compareData.forEach((item) => {
        item['fcn'] = fcn;
      });
      const fieldId = JSON.parse(jsonDataRaw)?.com?.id;
      const fieldType = JSON.parse(jsonDataRaw)?.com?.componentType;
      const fieldName = JSON.parse(jsonDataRaw)?.com?.label;
      this.auditV2.fieldId = fieldId;
      this.auditV2.fieldName = fieldName;
      this.auditV2.fieldType = fieldType;
    }
    this.compareFuncForArray(finalData, compareData, 'Role');
    return this.auditV2;
  }

  eventAudit(eventData, isDraggedFromPalette, jsonDataRaw): any {
    // AUDIT START
    let finalData = JSON.parse(eventData);
    let compareData: any;
    if (isDraggedFromPalette) {
      compareData = [];
    } else {
      compareData = JSON.parse(jsonDataRaw)?.com
        ? JSON.parse(jsonDataRaw)?.com.eventConfiguration
          ? [...JSON.parse(jsonDataRaw)?.com.eventConfiguration]
          : []
        : [...JSON.parse(jsonDataRaw)];
      const fieldId = JSON.parse(jsonDataRaw)?.com?.id;
      const fieldType = JSON.parse(jsonDataRaw)?.com?.componentType;
      const fieldName = JSON.parse(jsonDataRaw)?.com?.label;
      this.auditV2.fieldId = fieldId;
      this.auditV2.fieldName = fieldName;
      this.auditV2.fieldType = fieldType;
    }

    this.compareFuncForArray(finalData, compareData, 'Event');
    return this.auditV2;
  }

  validateAudit(validateData, isDraggedFromPalette, jsonDataRaw): any {
    // AUDIT START
    let finalData = JSON.parse(validateData);
    let compareData: any;
    if (isDraggedFromPalette) {
      compareData = [];
    } else {
      compareData = JSON.parse(jsonDataRaw)?.com
        ? JSON.parse(jsonDataRaw)?.com.validations
          ? [...JSON.parse(jsonDataRaw)?.com.validations]
          : []
        : [...JSON.parse(jsonDataRaw)];

      let fcn = JSON.parse(jsonDataRaw)?.fcn;
      compareData.forEach((item) => {
        item['fcn'] = fcn;
      });
      const fieldId = JSON.parse(jsonDataRaw)?.com?.id;
      const fieldType = JSON.parse(jsonDataRaw)?.com?.componentType;
      const fieldName = JSON.parse(jsonDataRaw)?.com?.label;
      this.auditV2.fieldId = fieldId;
      this.auditV2.fieldName = fieldName;
      this.auditV2.fieldType = fieldType;
    }

    this.compareFuncForArray(finalData, compareData, 'Validation');
    return this.auditV2;
  }

  TableConfigAudit(newTable, oldTable) {
    // AUDIT START
    let finalData = JSON.parse(newTable);
    let compareData = JSON.parse(oldTable);

    this.compareFuncForArray(finalData, compareData, 'TableConfig');
    return this.auditV2;
  }

  ruleAudit(ruleData, isDraggedFromPalette, jsonDataRaw): any {
    // AUDIT START
    let finalData = JSON.parse(ruleData);
    let compareData: any;
    if (isDraggedFromPalette) {
      compareData = [];
    } else {
      compareData = JSON.parse(jsonDataRaw)?.com
        ? JSON.parse(jsonDataRaw)?.com.ruleConfiguration
          ? [...JSON.parse(jsonDataRaw)?.com.ruleConfiguration]
          : []
        : [...JSON.parse(jsonDataRaw)];
      compareData.forEach((ele) => {
        ele['label'] = JSON.parse(jsonDataRaw)?.com
          ? JSON.parse(jsonDataRaw)?.com.label
          : '';
      });
      const fieldId = JSON.parse(jsonDataRaw)?.com?.id;
      const fieldType = JSON.parse(jsonDataRaw)?.com?.componentType;
      const fieldName = JSON.parse(jsonDataRaw)?.com?.label;
      this.auditV2.fieldId = fieldId;
      this.auditV2.fieldName = fieldName;
      this.auditV2.fieldType = fieldType;
    }

    this.compareFuncForArray(finalData, compareData, 'Rule');
    return this.auditV2;
  }

  compareFuncForArray(finalDataValue, compareDataValue, tabType) {
    switch (tabType) {
      case 'Table':
        if (
          JSON.stringify(finalDataValue) != JSON.stringify(compareDataValue)
        ) {
          // NOT EQUAL
          this.auditV2.tableJson.finalData = finalDataValue;
          this.auditV2.tableJson.oldData = compareDataValue
            ? compareDataValue
            : [];
          this.auditV2.tableJson.status = true;
        }
        break;
      case 'Event':
        if (
          JSON.stringify(finalDataValue) != JSON.stringify(compareDataValue)
        ) {
          this.auditV2.eventJson.finalData = finalDataValue;
          this.auditV2.eventJson.oldData = compareDataValue
            ? compareDataValue
            : [];
          this.auditV2.eventJson.status = true;
        }
        break;
      case 'Validation':
        if (
          JSON.stringify(finalDataValue) != JSON.stringify(compareDataValue)
        ) {
          this.auditV2.validateJson.finalData = finalDataValue;
          this.auditV2.validateJson.oldData = compareDataValue
            ? compareDataValue
            : [];
          this.auditV2.validateJson.status = true;
        }
        break;
      case 'Role':
        if (
          JSON.stringify(finalDataValue) != JSON.stringify(compareDataValue)
        ) {
          this.auditV2.roleJson.finalData = finalDataValue;
          this.auditV2.roleJson.oldData = compareDataValue
            ? compareDataValue
            : [];
          this.auditV2.roleJson.status = true;
        }
        break;
      case 'Rule':
        if (
          JSON.stringify(finalDataValue) != JSON.stringify(compareDataValue)
        ) {
          this.auditV2.ruleJson.finalData = finalDataValue;
          this.auditV2.ruleJson.oldData = compareDataValue
            ? compareDataValue
            : [];
          this.auditV2.ruleJson.status = true;
        }
        break;
      case 'TableConfig':
        if (
          JSON.stringify(finalDataValue) != JSON.stringify(compareDataValue)
        ) {
          // NOT EQUAL
          this.auditV2.sideTableConfig.finalData = finalDataValue;
          this.auditV2.sideTableConfig.oldData = compareDataValue
            ? compareDataValue
            : [];
          this.auditV2.sideTableConfig.status = true;
        }
        break;
    }
  }

  deleteComponent(comp): any {
    let id = comp?.id;
    let label = comp?.label;
    let compType = comp?.componentType;
    this.auditV2.fieldId = id;
    this.auditV2.fieldName = label;
    this.auditV2.fieldType = compType;
    this.auditV2.status = 'Deleted';

    return this.auditV2;
  }
}
